export default "__VITE_ASSET__145a16e0__"